import { render, staticRenderFns } from "./view-detail.vue?vue&type=template&id=59836eb6&scoped=true&"
import script from "./view-detail.vue?vue&type=script&lang=js&"
export * from "./view-detail.vue?vue&type=script&lang=js&"
import style0 from "./view-detail.vue?vue&type=style&index=0&id=59836eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59836eb6",
  null
  
)

export default component.exports